export let lignes = new Map([
	['1', '#5A1E82'],
	['5', '#00ACE7'],
	['8', '#84471C'],
	['9', '#E2001D'],
	['11', '#82419E'],
	['20', '#00A828'],
	['21', '#78003C'],
	['22', '#5A1E82'],
	['23', '#B82F89'],
	['25', '#A05909'],
	['29', '#E91E77'],
	['44', '#00B0A4'],
	['45', '#89CBBE'],
	['46', '#00B0A4'],
	['82', '#EC619F'],
	['E', '#FF7E00'],
	['E+', '#000000'],
	['G', '#FF9BAA'],
	['G+', '#000000'],
	// ['S.TB', '#5A1E82'],
	// ['S.TW', '#5A1E82'],
	['C1', '#000000'],
	['C7', '#000000'],
])

export let Lignes = []

export function setLines(data) {
	Lignes = data
}

export function lineServicesName(ligneName) {
	const ligne = Lignes.find((l) => l.ligne === ligneName)
	if (!ligne) return null
	let ret = []
	for (let e of ligne.services) {
		ret.push(e.name)
	}
	return ret
}
